import api from "../api";

const CAMPAIGN_BASE_URL = "/home/campaigns";

const isFormDataPayload = (payload) => {
  return typeof FormData !== "undefined" && payload instanceof FormData;
};

const buildConfig = (payload) => {
  if (isFormDataPayload(payload)) {
    // این باعث می‌شه axios/مرورگر خودش
    // Content-Type: multipart/form-data; boundary=... رو بسازه
    return { headers: { "Content-Type": undefined } };
  }
  return {};
};

const campaignApiService = {
  getCampaigns: async () => {
    const response = await api.get(`${CAMPAIGN_BASE_URL}/`);
    return response.data;
  },

  getCampaign: async (slug) => {
    const response = await api.get(`${CAMPAIGN_BASE_URL}/${slug}/`);
    return response.data;
  },

  getProductsExportData: async (slug) => {
    const response = await api.get(
      `${CAMPAIGN_BASE_URL}/${slug}/products/export-data/`
    );
    return response.data;
  },

  createCampaign: async (payload) => {

    const response = await api.post(`${CAMPAIGN_BASE_URL}/`, payload, buildConfig(payload));
    return response.data;
  },

  updateCampaign: async ({ slug, payload }) => {

    const response = await api.patch(`${CAMPAIGN_BASE_URL}/${slug}/`, payload, buildConfig(payload));
    return response.data;
  },

  deleteCampaign: async (slug) => {
    const response = await api.delete(`${CAMPAIGN_BASE_URL}/${slug}/`);
    return response.data;
  },

  searchProducts: async (query) => {
    const response = await api.get(`${CAMPAIGN_BASE_URL}/product-search/`, {
      params: { q: query },
    });
    return response.data;
  },

  addProduct: async ({ slug, productId }) => {
    const response = await api.post(`${CAMPAIGN_BASE_URL}/${slug}/products/`, {
      product_id: productId,
    });
    return response.data;
  },

  removeProduct: async ({ slug, productId }) => {
    const response = await api.delete(
      `${CAMPAIGN_BASE_URL}/${slug}/products/${productId}/`
    );
    return response.data;
  },

  importProducts: async ({ slug, file }) => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await api.post(
      `${CAMPAIGN_BASE_URL}/${slug}/products/import/`,
      formData,
{
        headers: {
          "Content-Type": undefined,
        },
      }
    );

    return response.data;
  },
};

export default campaignApiService;
